export const uploadUrl = "/campaigns/upload/cities/ack";
export const sampleURL = "/sample/bulk_cities_upload.csv";
